/* Mercado storefront fixes for the Lushy theme.
   Loaded right after vendor.js (jQuery) and before theme.js, see snippets/header-js.liquid.
   1. Locale-aware AJAX: theme.js calls '/cart/add.js', '/products/x.js', '/cart.js' at the store
      root. On /en that returns Arabic data and loses the language, so prefix the active locale
      root (Shopify.routes.root, e.g. '/en/') on those calls.
   2. Locale-aware links built by scripts (mini cart, quick view): rewrite root-relative store
      links to the active locale on click.
   3. Product page: localized option labels ("Color Name" -> Shade) and the brand above the title.
   4. Mini-cart quantity buttons: localized accessible names.
   5. Sort menus: Shopify sends the sort option names in English; show the theme's translated labels.
   6. Cart totals. Shopify's /cart/change.js and /cart/update.js answers carry a total_price that
      includes the cheapest delivery rate while the cart is under the free-shipping threshold
      (seen: +20.00 NIS); /cart.js never does. Reproduced with a bare fetch and no theme or app
      scripts, so it is platform behaviour, not something the theme can switch off. The theme prints
      cart.total_price straight from those answers, so: (a) rebuild total_price from the answer's own
      fields (original total minus all discounts, which is exactly what /cart.js returns), (b) run
      cart writes one at a time so rapid taps cannot overtake each other, (c) show an updating state
      and hold the checkout buttons until the last write has answered.
   7. Accessibility: the header cart toggle is a <span>; make it a keyboard button with a name.
      Name the unlabeled close buttons, and keep aria-expanded in step with collapsible menus. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var needsPrefix = root !== '/';
  var storePath = /^\/(products|collections|cart|pages|blogs|search|account|policies|checkout)(\/|\?|#|$)/;
  var strings = window.mcStrings || {};

  function localize(url) {
    if (!needsPrefix || typeof url !== 'string') return url;
    if (url.charAt(0) !== '/' || url.charAt(1) === '/') return url;
    if (url.indexOf(root) === 0) return url;
    return storePath.test(url) ? root + url.slice(1) : url;
  }
  window.mcLocalizeUrl = localize;

  var $ = window.jQuery;
  if ($ && $.ajaxPrefilter && needsPrefix) {
    $.ajaxPrefilter(function (options) {
      options.url = localize(options.url);
    });
  }

  if (needsPrefix) {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="/"]') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      var fixed = localize(href);
      if (fixed !== href) a.setAttribute('href', fixed);
    }, true);
  }

  function enhanceProductPage() {
    var map = [
      [/colou?r|shade|لون|درجة/i, strings.shade],
      [/size|volume|حجم/i, strings.size],
      [/scent|fragrance|رائحة/i, strings.scent]
    ];
    document.querySelectorAll('.selector-wrapper > label').forEach(function (label) {
      var node = label.firstChild;
      if (!node || node.nodeType !== 3) return;
      var name = node.nodeValue.replace(/\s+/g, ' ').replace(':', '').trim();
      if (!name) return;
      for (var i = 0; i < map.length; i++) {
        if (map[i][1] && map[i][0].test(name)) {
          node.nodeValue = map[i][1] + ': ';
          label.classList.add('mc-opt-localized');
          return;
        }
      }
    });
    // Store pickup drawer: the option names ("COLOR: 20 COY") and its close button in the page language.
    // The theme rewrites that line with the raw option names on every variant change, so the line is watched.
    var fixPickup = function (p) {
      var w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null), n, nodes = [];
      while ((n = w.nextNode())) nodes.push(n);
      nodes.forEach(function (node) {
        var v = node.nodeValue;
        var nv = v.replace(/(^|,\s*)([^:,]+?)\s*:/g, function (all, pre, name) {
          for (var i = 0; i < map.length; i++) if (map[i][1] && map[i][0].test(name)) return pre + map[i][1] + ':';
          return all;
        });
        if (nv !== v) node.nodeValue = nv;
      });
    };
    var watchPickup = function () {
      var x = document.querySelector('pickup-availability-drawer .pickup-availability-drawer-button');
      if (x && strings.close && x.getAttribute('aria-label') !== strings.close) x.setAttribute('aria-label', strings.close);
      var p = document.querySelector('pickup-availability-drawer .pickup-availability-variant');
      if (!p || p._mc) return;
      p._mc = true;
      fixPickup(p);
      new MutationObserver(function () { fixPickup(p); }).observe(p, { childList: true, characterData: true, subtree: true });
    };
    if (document.querySelector('pickup-availability')) {
      watchPickup();
      new MutationObserver(watchPickup).observe(document.body, { childList: true });
    }
    var title = document.querySelector('.product-single__title');
    var vendor = document.querySelector('.product-single__vendor small:last-child');
    if (title && vendor && !document.querySelector('.mc-pdp-vendor')) {
      var brand = vendor.textContent.trim();
      if (brand) {
        var a = document.createElement('a');
        a.className = 'mc-pdp-vendor';
        a.textContent = brand;
        a.href = strings.vendorHandleUrl || ('/collections/vendors?q=' + encodeURIComponent(brand));
        title.parentNode.insertBefore(a, title);
      }
    }
  }

  function labelMiniCart(box) {
    if (strings.decrease) box.querySelectorAll('.js-qty__minus[aria-label]').forEach(function (b) { b.setAttribute('aria-label', strings.decrease); });
    if (strings.increase) box.querySelectorAll('.js-qty__plus[aria-label]').forEach(function (b) { b.setAttribute('aria-label', strings.increase); });
    // theme.js draws each drawer line as <img src="{{ item.image }}"> — the original upload (seen: 2000 px, 62 KB)
    // for a 104 px box. Ask the CDN for a 240 px copy (~4 KB) and give the box its size before the picture arrives.
    box.querySelectorAll('.mini-cart-image img').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      if (!src || /[?&]width=/.test(src) || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(src)) return;
      img.setAttribute('src', src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=240');
      img.setAttribute('width', '104');
      img.setAttribute('height', '104');
      img.setAttribute('decoding', 'async');
    });
  }

  function localizeSort(scope) {
    var labels = strings.sort;
    if (!labels) return;
    (scope || document).querySelectorAll('select[name="sort_by"] option').forEach(function (o) {
      var text = labels[o.value];
      if (text && o.textContent !== text) o.textContent = text;
    });
  }

  function watchSort() {
    var select = document.querySelector('select[name="sort_by"]');
    if (!select) return;
    localizeSort();
    var section = select.closest('.shopify-section') || select.parentNode;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; localizeSort(section); });
    }).observe(section, { childList: true, subtree: true });
  }

  var cartWrite = /\/cart\/(change|update|add|clear)\.js(\?|$)/;
  var cartTotals = /\/cart\/(change|update)\.js(\?|$)/;
  var cartRead = /\/cart\.js(\?|$)/;
  var cartPending = 0;
  var cartIntent = 0;       // a quantity control was used; the theme debounces before it writes
  var lastWriteEnd = 0;
  var checkoutWanted = null;

  function cartIdle() { return cartPending === 0 && !cartIntent; }

  function pendingDone() {
    cartPending = Math.max(0, cartPending - 1);
    if (cartIdle()) cartBusy(false);
  }

  function armIntent() {
    clearTimeout(cartIntent);
    cartIntent = setTimeout(function () { cartIntent = 0; if (cartIdle()) cartBusy(false); }, 1500);
    cartBusy(true);
  }

  function clearIntent() {
    if (cartIntent) { clearTimeout(cartIntent); cartIntent = 0; }
  }

  // Cart page: if a write came from somewhere else (the drawer), redraw the lines and the subtotal from /cart.js
  function syncCartPage() {
    if (!document.body.classList.contains('template-cart') || !window.fetch || !window.QtySelector || !$) return;
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var lines = {};
        document.querySelectorAll('.cart-table .js-qty__input[data-line]').forEach(function (i) { lines[i.getAttribute('data-line')] = parseInt(i.value, 10); });
        var keys = Object.keys(lines);
        var same = keys.length === cart.items.length;
        for (var k = 0; same && k < keys.length; k++) {
          var item = cart.items[parseInt(keys[k], 10) - 1];
          if (!item || item.quantity !== lines[keys[k]]) same = false;
        }
        if (same) return;
        if (cart.item_count === 0) { window.location.reload(); return; }
        var ctx = { cache: { $body: $('body'), $subtotal: $('#CartSubtotal'), $discountTotal: $('#cartDiscountTotal'), $cartTable: $('.cart-table'), $cartTemplate: $('#CartProducts') }, settings: {} };
        QtySelector.prototype.updateCartItemCallback.call(ctx, cart);
      })
      .catch(function () {});
  }

  function normalizeCart(text) {
    try {
      var cart = JSON.parse(text);
      if (cart && typeof cart.original_total_price === 'number' && typeof cart.total_discount === 'number') {
        cart.total_price = cart.original_total_price - cart.total_discount;
        return JSON.stringify(cart);
      }
    } catch (err) {}
    return text;
  }

  function cartBusy(on) {
    document.documentElement.classList.toggle('mc-cart-busy', on);
    document.querySelectorAll('.btn-cart-checkout, .js-cart-btn-checkout').forEach(function (b) {
      if (on) { b.setAttribute('aria-disabled', 'true'); b.classList.add('mc-busy'); }
      else { b.removeAttribute('aria-disabled'); b.classList.remove('mc-busy'); }
    });
    var status = document.getElementById('mc-cart-status');
    if (!status) {
      var sub = document.getElementById('CartSubtotal');
      if (sub && sub.parentNode) {
        status = document.createElement('p');
        status.id = 'mc-cart-status';
        status.className = 'mc-cart-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        sub.parentNode.insertAdjacentElement('afterend', status);
      }
    }
    if (status) status.textContent = on ? (strings.loading || 'Updating…') : '';
    if (!on) {
      syncCartPage();
      if (checkoutWanted) {
        var b = checkoutWanted;
        checkoutWanted = null;
        setTimeout(function () { b.click(); }, 0);
      }
    }
  }

  if ($ && $.ajax && $.Deferred) {
    var origAjax = $.ajax;
    var cartQueue = $.Deferred().resolve().promise();
    $.ajax = function (url, options) {
      if (url && typeof url === 'object') { options = url; url = undefined; }
      var target = url || (options && options.url) || '';
      if (typeof target !== 'string') return origAjax.apply($, arguments);
      if (!cartWrite.test(target)) {
        var jqr = origAjax.apply($, arguments);
        // reads that follow a write keep the updating state until the numbers on screen are final
        if (cartRead.test(target) && jqr && jqr.always && (cartPending > 0 || Date.now() - lastWriteEnd < 1500)) {
          cartPending++;
          cartBusy(true);
          jqr.always(pendingDone);
        }
        return jqr;
      }
      options = $.extend({}, options);
      if (url) options.url = url;
      if (cartTotals.test(target)) {
        var prevFilter = options.dataFilter;
        options.dataFilter = function (data, type) {
          var out = prevFilter ? prevFilter.call(this, data, type) : data;
          return typeof out === 'string' ? normalizeCart(out) : out;
        };
      }
      var d = $.Deferred();
      clearIntent();
      cartPending++;
      cartBusy(true);
      var run = function () {
        var jq = origAjax.call($, options);
        jq.done(function () { d.resolveWith(this, arguments); }).fail(function () { d.rejectWith(this, arguments); });
        return jq.then(null, function () { return $.Deferred().resolve().promise(); });
      };
      cartQueue = cartQueue.then(run, run).always(function () {
        lastWriteEnd = Date.now();
        pendingDone();
      });
      var p = d.promise();
      p.abort = function () {};
      return p;
    };
    // The cart page waits 200 ms and checks availability before it writes: hold checkout from the first tap
    document.addEventListener('click', function (e) {
      var q = e.target && e.target.closest ? e.target.closest('.cart-table .js-qty__adjust') : null;
      if (q) armIntent();
    }, true);
    document.addEventListener('change', function (e) {
      var q = e.target && e.target.closest ? e.target.closest('.cart-table .js-qty__input') : null;
      if (q) armIntent();
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.btn-cart-checkout, .js-cart-btn-checkout, button[name="checkout"]') : null;
      if (!b || cartIdle()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      checkoutWanted = b;
    }, true);
  }

  // New customer accounts: any leftover "open login popup" control goes to Shopify's sign-in page
  if (strings.loginUrl && strings.loginUrl.indexOf('/account/login') === -1) {
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.js-open-login') : null;
      if (!b) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = strings.loginUrl;
    }, true);
  }

  function enhanceA11y() {
    document.querySelectorAll('.js-toggle-cart').forEach(function (t) {
      if (t.tagName === 'BUTTON' || t.tagName === 'A' || t.hasAttribute('role')) return;
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      if (strings.cart && !t.textContent.trim()) t.setAttribute('aria-label', strings.cart);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
      });
    });
    if (strings.close) {
      document.querySelectorAll('button.close, .drawer__close button, .mini-cart-content .close').forEach(function (b) {
        var label = b.getAttribute('aria-label');
        if (!label || /^close$/i.test(label)) {
          if (!b.textContent.trim() || /^close$/i.test(label || '')) b.setAttribute('aria-label', strings.close);
        }
      });
    }
    if ($ && $.fn) {
      $(document).on('shown.bs.collapse hidden.bs.collapse', function (e) {
        var id = e.target && e.target.id;
        if (!id) return;
        var open = e.type === 'shown';
        try {
          document.querySelectorAll('[data-target="#' + id + '"], [href="#' + id + '"]').forEach(function (b) {
            b.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        } catch (err) {}
      });
      document.querySelectorAll('[data-toggle="collapse"][aria-expanded]').forEach(function (b) {
        var sel = b.getAttribute('data-target') || b.getAttribute('href');
        var panel = sel && sel.charAt(0) === '#' ? document.getElementById(sel.slice(1)) : null;
        if (panel) b.setAttribute('aria-expanded', panel.classList.contains('show') ? 'true' : 'false');
      });
    }
  }

  // Desktop menu: a dropdown opens from its item's start edge; the items near the far edge of the
  // viewport open from the end edge instead, so no dropdown is cut off and the page never scrolls sideways
  function fitDropdowns() {
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var docW = document.documentElement.clientWidth;
    document.querySelectorAll('.site-header .site-nav > li').forEach(function (li) {
      var dd = li.querySelector(':scope > .site-nav__dropdown');
      if (!dd || getComputedStyle(li).position === 'static') return;
      var w = dd.offsetWidth;
      if (!w) return;
      var r = li.getBoundingClientRect();
      var flip = rtl ? (r.right - w < 4) : (r.left + w > docW - 4);
      li.classList.toggle('mc-dd-flip', flip);
    });
  }
  function watchDropdowns() {
    var t;
    var run = function () { clearTimeout(t); t = setTimeout(fitDropdowns, 80); };
    fitDropdowns();
    window.addEventListener('resize', run);
    document.addEventListener('shopify:section:load', run);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitDropdowns);
  }

  function init() {
    enhanceProductPage();
    watchSort();
    enhanceA11y();
    watchDropdowns();
    var cart = document.querySelector('.js-mini-cart-content') || document.querySelector('.mini-cart-content');
    if (cart) {
      labelMiniCart(cart);
      new MutationObserver(function () { labelMiniCart(cart); }).observe(cart, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
